import {useEditMode} from 'Event/EditModeProvider'
import styled from 'styled-components'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import BlogPosts from 'Event/template/NiftyFifty/Dashboard/Home/BlogPosts'
import WelcomeTextConfig from 'Event/template/NiftyFifty/Dashboard/Home/WelcomeTextConfig'
import {useToggle} from 'lib/toggle'
import React from 'react'
import BodyHTMLEmbed from 'Event/Dashboard/components/BodyHtmlEmbed'
import {useAttendeeVariables} from 'Event'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import TeamAccessControls from 'Event/Dashboard/TeamAccessControls'
import CountDownTimers from 'Event/template/NiftyFifty/Dashboard/CountDownTimers'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'

export default function Home() {
  const {flag: welcomeConfigVisible, toggle: toggleWelcomeConfig} = useToggle()

  return (
    <>
      <EditModeOnly>
        <WelcomeTextConfig
          showing={welcomeConfigVisible}
          onClose={toggleWelcomeConfig}
        />
      </EditModeOnly>
      <Editable onEdit={toggleWelcomeConfig}>
        <WelcomeText />
      </Editable>
      <TeamAccessControls />
      <CountDownTimers />
      <BlogPosts />
      <BodyHTMLEmbed />
    </>
  )
}

function WelcomeText() {
  const template = useNiftyFiftyTemplate()
  const isEditMode = useEditMode()
  const {welcomeText, welcomeTextJustify, welcomeTextWidth} = template
  const v = useAttendeeVariables()

  if (!welcomeText && !isEditMode) {
    return null
  }

  return (
    <FlexContainer justify={welcomeTextJustify}>
      <TextContainer width={welcomeTextWidth}>
        <Text
          aria-label="welcome"
          hasMinHeight={isEditMode}
          justify={welcomeTextJustify}
        >
          {v(welcomeText)}
        </Text>
      </TextContainer>
    </FlexContainer>
  )
}

const FlexContainer = styled.div<{
  justify: string
}>`
  display: flex;
  justify-content: ${(props) =>
    props.justify === 'center'
      ? 'center;'
      : props.justify === 'right'
      ? 'flex-end;'
      : 'flex-start;'};
`

const TextContainer = styled.div<{
  width: number
}>`
  width: ${(props) => props.width ?? '100'}%;
`

const Text = styled(HTMLContent)<{
  hasMinHeight: boolean
  justify: string
}>`
  line-height: 1.5;
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
  text-align: ${(props) => props.justify ?? 'left'};
  margin: 0 0 30px;

  ${(props) => (props.hasMinHeight ? 'min-height: 42px;' : '')}
`
